<template>
  <div class="user_delete">
  </div>
</template>

<script>

  export default {
    name: 'UserDelete',
    data() {
      return {
        user: [],
      }
    },
    created() {
      this.$http.delete(`user/` + this.$route.params.id, {
        redirectOnFailure: {name: 'UserList', params: {id: this.$route.params.id}},
        redirectOnSuccess: {name: 'UserList', params: {id: this.$route.params.id}},
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/delete.vue